import React, { Component, useEffect, useState } from 'react';
import * as d3 from "d3";

function Age (props) {

    const age = props.age,
        setAge = props.setAge

    useEffect(() => {})

    return (
        <div className="general_field">
            <legend>How <strong>old</strong> are you? Minors cannot participate.</legend>
            <div className="general_options">
                <label>
                    <input 
                        type="radio" 
                        name="age" 
                        value="18-27"
                        checked={age === "18-27"}
                        onChange={() => setAge("18-27")}
                    />
                    18–27
                </label>
                <label>
                    <input 
                        type="radio" 
                        name="age" 
                        value="28-37"
                        checked={age === "28-37"}
                        onChange={() => setAge("28-37")}
                    />
                    28–37
                </label>
                <label>
                    <input 
                        type="radio" 
                        name="age" 
                        value="38-47"
                        checked={age === "38-47"}
                        onChange={() => setAge("38-47")}
                    />
                    38–47
                </label>
                <label>
                    <input 
                        type="radio" 
                        name="age" 
                        value="48-57"
                        checked={age === "48-57"}
                        onChange={() => setAge("48-57")}
                    />
                    48–57
                </label>
                <label>
                    <input
                        type="radio" 
                        name="age" 
                        value="58-67"
                        checked={age === "58-67"}
                        onChange={() => setAge("58-67")}
                    />
                    58–67
                </label>
                <label>
                    <input
                        type="radio" 
                        name="age" 
                        value="+67"
                        checked={age === "+67"}
                        onChange={() => setAge("+67")}
                    />
                    More than 67
                </label>
                <label style={{marginTop: '0.3em'}}>
                    <input
                        type="radio" 
                        name="age" 
                        value="no_answer"
                        checked={age === "no_answer"}
                        onChange={() => setAge("no_answer")}
                    />
                    I prefer not to answer.
                </label>
            </div>
        </div>
    )
}

export default Age;